// extracted by mini-css-extract-plugin
export default {"cls1":"aqqatbLgWonONVdrqBbS","cls2":"JFQibJUmWycaCC0V8FT1 aqqatbLgWonONVdrqBbS"};